export enum QuoteStatus {
  New = 0,
  Cancelled = 1,
  Rejected = 2,
  Approved = 3,
  Sent = 4
}
